import { alpha } from '@mui/material/styles'

const styles = {
  table: {
    color: 'neutral.main',
    pb: 6,
    height: '100%',

    '& .MuiChip-root': {
      m: 0,
    },
  },
  isResultTable: {
    pb: 0,
  },
  headerRowGroup: {
    position: 'sticky',
    top: 112,
    backgroundColor: 'neutral.white',
    zIndex: 2,
  },
  isResultHeaderRowGroup: {
    position: 'fixed',
    top: 96,
  },
  isResultBodyRowGroup: {
    pt: 5,
  },
  row: {
    display: 'flex',
    width: '100vw',
    alignItems: 'center',
    border: theme => `solid 1px ${theme.palette.neutral.lightest}`,
    position: 'relative',
    overflow: 'hidden',
  },
  headerRow: { height: 40 },
  simpleRow: {
    height: 64,
    backgroundColor: 'neutral.white',
  },

  simpleCell: {
    width: '50%',
    px: 1,
  },
  simpleCellShipmentDestiny: {
    pl: 2,
    pr: 1,
  },
  actionCell: {
    width: 54,
    height: '100%',
    position: 'absolute',
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,

    '& svg': {
      width: 24,
      height: 24,
    },
  },
  actionCellGradient: {
    background: theme =>
      `linear-gradient(270deg, ${theme.palette.neutral.white} 25%, ${alpha(
        theme.palette.neutral.white,
        0,
      )} 100%)`,
  },
  filtersButtonHasFilter: {
    '& svg': {
      color: 'info.dark',
    },
    '&:hover svg': {
      color: 'info.dark',
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'info.dark',
      color: 'neutral.white',
      position: 'absolute',
      top: 5,
      boxShadow: theme => theme.shadows[1],
    },
  },
  shippingCode: {
    width: theme => `calc(100% - ${theme.spacing(1)})`,
    mb: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    direction: 'rtl',
    textAlign: 'left',
  },
  recipientAddress: {
    width: theme => `calc(100% - ${theme.spacing(1)})`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  date: {
    mt: 0.5,
  },
  dateSeparator: {
    color: 'neutral.lighter',
  },
  getStatusBackground: (color, type) => {
    return {
      background: theme => {
        const newColor =
          color === 'primary'
            ? theme.palette.primary.lightestPlus
            : color === 'yellow'
            ? theme.palette.yellow.lightest
            : theme.palette.neutral.white

        return type === 'actionCell'
          ? `linear-gradient(270deg, ${newColor} 25%, ${alpha(
              newColor,
              0,
            )} 100%)`
          : newColor
      },
    }
  },
  emptyState: {
    pt: 4,
    px: 2,
  },
  emptyStateTitle: {
    mb: 1,
  },
  emptyStateButton: {
    display: 'flex',
    mt: 4,
    mx: 'auto',
  },
}

export default styles
